import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

/**
 * WAT-12043 / YFH-AMP108 — shared focus ring for interactive elements on
 * Channel Line-up. `outline: 2px solid #3885E1` (DDS `focusOutline.blue`).
 *
 * Exists because the DDS `ux*` button variants
 * (uxprimary/uxsecondary/uxtext/uxlink) ship WITHOUT a :focus-visible rule
 * of their own, and DtvButton also disables the ButtonBase ripple, so a
 * keyboard user sees nothing on focus without this helper. Spread into
 * every audited CTA on the page (PackageCmprGrid.styles.ts, CategoryHeader,
 * Footer, ChannelRow, SvodChannelRow).
 *
 * Two knobs the caller picks:
 *   - selector — `&.Mui-focusVisible` for MUI ButtonBase-descended widgets
 *     (MUI toggles the class on focus-visible), or `&:focus-visible` for
 *     native `<button>` / `component="button"` elements (browser-driven).
 *   - outlineOffset — negative for MUI widgets so the ring sits inside
 *     the element and doesn't clip under sticky headers; positive for the
 *     small pill/icon triggers so the ring reads clearly. Kept as a
 *     per-call argument (not a single constant) so both variants stay
 *     correct at every call site.
 */
export const focusVisibleOutline = (
  selector: "&.Mui-focusVisible" | "&:focus-visible" = "&:focus-visible",
  outlineOffset: string = "2px"
) => ({
  [selector]: {
    outline: `2px solid ${colorPalette.focusOutline.blue}`,
    outlineOffset
  }
});
